/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * HintModal.web.tsx - Hint modal
 */

import Modal from 'react-modal';
import HintComponent from './HintComponent';
import './HintModal.web.css';
import { HintModalProps } from './HintModalProps';

const HintModal = ({ question, hintVisible, toggleHint }: HintModalProps) => {
  return (
    <Modal
      isOpen={hintVisible}
      onRequestClose={() => {
        toggleHint();
      }}
      style={{
        overlay: {
          backgroundColor: 'rgba(255, 255, 255, 0)', border: '0px', overflow: 'hidden', maxHeight: '100%', inset: '0px'
        },
        content: {
          backgroundColor: 'rgba(255, 255, 255, 0)', border: '0px', overflow: 'hidden', maxHeight: '100%', inset: '5%', position: 'absolute', padding: '0px'
        }
      }}
      ariaHideApp={false}
    >
      <div id="hint_wrapper" >
        <div id="hint_content" >
          <div id="hint_frames" >
            <HintComponent question={question} />
          </div>
          <div id="hint_bottom">
            <button
              id="hint_close_button"
              onClick={() => {
                toggleHint();
              }}
            >
              <p id="hint_close_button_text" > Hide </p>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HintModal;
